module.exports = __webpack_public_path__ + "img/图层 33.39bedcdc.png";